import React from 'react';
import './App.css';
import { convertDataToUrl, eventGuideData, filter_media } from './Common';
import { NavLink } from "react-router-dom";
import Icon from '@mdi/react';
import {
  mdiBookOpenVariant,
  mdiPostOutline,
  mdiFire,
} from '@mdi/js';


class SideNavBar extends React.Component {
  render() {
    const { blogEntries } = this.props;
    const data = filter_media(this.props.data, ['collectionFilter']);
    // TODO remove the x.popular condition, just kept for backwards compatibility with cache
    const popularContent = data.filter(x => x.recent_rating_count || x.popular).sort((a, b) => b.recent_rating_count - a.recent_rating_count).splice(0, 10);

    return (
      <div className="side-nav">
        <div className="infopanel" style={{ position: 'fixed', height: 'unset' }}>
          <div className="infopanel-inner">
            <h1 className="subtitle profile-icons">
              <Icon className='icon' path={mdiBookOpenVariant} />
              Reading Guides
            </h1>
            <NavLink
              className='link-text'
              to={'/startingpoints'}
              style={{ display: 'block' }}
            >
              Where to Start Reading
            </NavLink>
            <NavLink
              className='link-text'
              to={'/omnibus_guide'}
              style={{ display: 'block' }}
            >
              Marvel Omnibus Guide
            </NavLink>
            {
              Object.entries(eventGuideData).map(([path, guideData]) => {
                return (
                  <NavLink
                    className='link-text'
                    to={`/${path}`}
                    style={{ display: 'block' }}
                    key={`side-nav-${guideData.title}`}
                  >
                    {`${guideData.title} Reading Order`}
                  </NavLink>
                )
              })
            }
          </div>
          <div className="infopanel-inner">
            <h1 className="subtitle profile-icons">
              <Icon className='icon' path={mdiPostOutline} />
              Recent Blog Posts
            </h1>
            {
              blogEntries?.slice(0, 5)?.map(x => {
                return (
                  <NavLink
                    className='link-text'
                    to={`/blog/${convertDataToUrl(x)}`}
                    style={{ display: 'block' }}
                    key={`side-nav-${x.title}`}
                  >
                    {`${x.title}`}
                  </NavLink>
                )
              })
            }
          </div>
          <div className="infopanel-inner">
            <h1 className="subtitle profile-icons">
              <Icon className='icon' path={mdiFire} />
              Popular Content Last 30 Days
            </h1>
            {
              popularContent?.map(x => {
                return (
                  <NavLink
                    className='link-text'
                    to={`/content/${convertDataToUrl(x)}`}
                    style={{ display: 'block' }}
                    key={`side-nav-${x.title}`}
                  >
                    {`${x.title}`}
                  </NavLink>
                )
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

export default SideNavBar;
